<template>
    <div class="columns is-multiline is-centered m-t-10">
        <b-loading :is-full-page="true" :active.sync="loading" :can-cancel="true"></b-loading>
        
        <div class="column is-two-thirds has-text-centered">
            <h2 class="title">{{customPage.title}}</h2>
        </div>

        <div class="column is-two-thirds m-t-10">
            <div class="ql-editor" v-html="customPage.content"></div>
        </div>
        
    </div>
</template>

<script>
import { getHandler } from '../../../services/http'
export default {
    props:{
        detailUrl:{
            type:String,
            default:""
        }
    },
    data(){
        return{
            customPage:{},
            loading:false
        }
    },
    methods:{
        async fetchDetails(){
            this.loading = true
            this.customPage = await getHandler(this.detailUrl, {error:false, success:false})
            this.loading = false
        }
    },
    created(){
        this.fetchDetails()
    }
}
</script>